import axios from 'axios';

export default async function Logout(data, onSuccess, onError){
    try{
        const response = await axios.get("/logout", {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            // baseURL: "https://shielded-lowlands-66092.herokuapp.com/"
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });
        onSuccess && onSuccess(response);
    }
    catch(err){
        console.log(err);
        onError && onError(err);
    }
}